/**
 * targetId로 스크롤
 * @param targetId 타겟이 되는 요소의 id
 * @param offset
 */
export const scrollToElement = (targetId: string, offset: number = 0) => {
  const element = document.getElementById(targetId);
  if (element) {
    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
  }
};
